<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800px">
      <v-form ref="AddAccount" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center dialog-header">
            <span>{{ action + " Instructor" }}</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>
          <v-divider class="mt-3"></v-divider>

          <v-card-text class="px-4" style="max-height: 600px">
            <v-container class="d-flex justify-center">
              <v-expand-x-transition>
                <v-card
                  v-show="personal_info"
                  class="elevation-2 pa-2"
                  :height="cardH"
                  :width="cardW"
                >
                  <v-row>
                    <v-col cols="12">Personal Information</v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="fname"
                        label="First Name"
                        :rules="[formRules.required]"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        variant="outlined"
                        density="compact"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="mname"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        label="Middle Name"
                        variant="outlined"
                        density="compact"
                    /></v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="lname"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        label="Last Name"
                        :rules="[formRules.required]"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="suffix"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        label="Suffix"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                  </v-row>
                </v-card>
              </v-expand-x-transition>
              <v-expand-x-transition>
                <v-card
                  v-show="program_assigned"
                  class="elevation-2"
                  :height="cardH"
                  :width="cardW"
                >
                  <v-row>
                    <v-col cols="12">
                      <div class="pa-2">Please Select Program to Assign</div>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        :rules="[formRules.required]"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        v-model="assigned_prog"
                        :value="i.id"
                        v-for="i in programList"
                        :key="i.id"
                        :label="i.name"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card>
              </v-expand-x-transition>
              <v-expand-x-transition>
                <v-card
                  v-show="credentials"
                  class="elevation-2 pa-2"
                  :height="cardH"
                  :width="cardW"
                >
                  <v-row>
                    <v-col cols="12">User Credentials</v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="email"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        label="Email"
                        :readonly="action == 'Edit' ? true : false"
                        prepend-inner-icon="mdi-email"
                        :rules="[formRules.required, formRules.email]"
                        @change="checkEmail()"
                        :error-messages="emailError"
                        variant="outlined"
                        density="compact"
                        class="mb-3" />

                      <v-text-field
                        v-model="password"
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        :label="action == 'Edit' ? 'New Password' : 'Password'"
                        :type="showPassword ? 'text' : 'password'"
                        :append-inner-icon="
                          showPassword ? 'mdi-eye-off' : 'mdi-eye'
                        "
                        @click:append-inner="showPassword = !showPassword"
                        :rules="[formRules.required, formRules.password]"
                        prepend-inner-icon="mdi-lock"
                        variant="outlined"
                        density="compact"
                        class="mb-5" />
                      <v-text-field
                        class="font-size-14"
                        :class="action == 'Edit' ? 'd-none' : ''"
                        outlined
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        variant="outlined"
                        density="compact"
                        v-model="confirmPassword"
                        :rules="[
                          formRules.required,
                          formRules.confirmPassword(confirmPassword, password),
                        ]"
                        :type="showPasswordConfirm ? 'text' : 'password'"
                        :append-inner-icon="
                          showPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'
                        "
                        @click:append-inner="
                          showPasswordConfirm = !showPasswordConfirm
                        "
                        prepend-inner-icon="mdi-lock"
                        label="Confirm Password"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                </v-card>
              </v-expand-x-transition>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              text="Prev"
              color="success"
              variant="flat"
              @click="Prev()"
              :disabled="personal_info"
            ></v-btn>

            <v-spacer></v-spacer>

            <v-btn
              v-if="action == 'Add' ? !credentials : !program_assigned"
              color="success"
              :text="'Next'"
              variant="flat"
              @click="Next()"
            ></v-btn>
            <v-btn
              color="success"
              v-if="action == 'Add' ? credentials : program_assigned"
              :text="'Submit'"
              variant="flat"
              @click="action == 'Add' ? submit() : update()"
              :loading="btnLoading"
              :disabled="btnLoading"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      personal_info: true,
      program_assigned: false,
      credentials: false,
      cardH: 400,
      cardW: 600,
      dialog: false,
      step: { id: 1, name: "Personal Information" },
      email: null,
      password: null,
      emailError: null,
      confirmPassword: null,
      showPassword: false,
      showPasswordConfirm: false,
      id: null,
      fname: null,
      lname: null,
      mname: null,
      suffix: null,
      programList: [],
      usertypeList: [],
      assigned_prog: [],
      assignedModulesList: [],
      btnLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.personal_info = true;
        this.program_assigned = false;
        this.credentials = false;
        this.$refs.AddAccount.reset();
        this.$refs.AddAccount.resetValidation();
        if (data.id) {
          console.log(data);
          this.id = data.id;
          this.fname = data.fname;
          this.lname = data.lname;
          this.mname = data.mname;
          this.email = data.email;
          this.assigned_prog = data.assigned_as_instructor_id;
        }
      },
      deep: true,
    },
  },
  methods: {
    checkEmail() {
      this.emailChecking = true;
      this.axiosCall("/auth/checkEmailIfExist/" + this.email, "GET").then(
        (res) => {
          console.log(res.data);
          if (res.data) {
            this.emailError = "Email Already Exist!";
          } else {
            this.emailError = "";
          }
          this.emailChecking = false;
        },
      );
    },
    initialize() {
      this.getProgramByInstitute();
    },

    async submit() {
      let validate = await this.$refs.AddAccount.validate();
      this.btnLoading = true;
      if (validate.valid) {
        let data = {
          email: this.email,
          password: this.password,
          fname: this.fname,
          mname: this.mname,
          lname: this.lname,
          suffix: this.suffix,
          assigned_prog: JSON.stringify(this.assigned_prog),
        };

        this.axiosCall("/auth/registerInstructor", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let validate = await this.$refs.AddAccount.validate();
      this.btnLoading = true;
      console.log(validate);
      if (this.assigned_prog.length == 0) {
        this.btnLoading = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please select progran to assign.";
        this.fadeAwayMessage.header = "System Message";
      } else {
        let data = {
          fname: this.fname,
          mname: this.mname,
          lname: this.lname,
          suffix: this.suffix,
          assigned_prog: JSON.stringify(this.assigned_prog),
        };

        this.axiosCall(
          "/user-details/updateAssignedProgram/" + this.data.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeOjtInstructorDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },
    Next() {
      if (this.personal_info) {
        if (this.fname == null || this.lname == null) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message =
            "Please fill-up required fields for users Information!";
          this.fadeAwayMessage.header = "System Message";
        } else {
          this.personal_info = !this.personal_info;
          setTimeout(() => {
            this.program_assigned = !this.program_assigned;
          }, 100);
        }
      }

      if (this.program_assigned) {
        console.log("condito", this.assigned_prog ? true : false);
        if (!this.assigned_prog.length > 0) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Please select program to assign.";
          this.fadeAwayMessage.header = "System Message";
        } else {
          this.program_assigned = !this.program_assigned;
          setTimeout(() => {
            this.credentials = !this.credentials;
          }, 100);
        }
      }

      //  else if (this.step.id == 3) {
      //   if (this.$refs.Step3Formref.validate()) {
      //     this.step = { id: 4, name: "Otp Confirmation" };
      //   }
      // }
    },

    Prev() {
      console.log("prev");
      if (this.program_assigned) {
        this.program_assigned = !this.program_assigned;
        setTimeout(() => {
          this.personal_info = !this.personal_info;
        }, 100);
      }

      if (this.credentials) {
        this.credentials = !this.credentials;
        setTimeout(() => {
          this.program_assigned = !this.program_assigned;
        }, 100);
      }
    },

    getProgramByInstitute() {
      this.axiosCall("/program/getProgramsByInstitute", "GET").then((res) => {
        console.log(res.data);
        this.programList = res.data;
      });
    },
    refresh() {
      this.fname = null;
      this.lname = null;
      this.mname = null;
      this.email = null;
      this.password = null;
      this.confirmPassword = null;
      this.verifyModel.user_roleID = null;
      this.verifyModel.assignedModuleID = null;
      this.verifyModel.usertypeID = null;
    },
  },
};
</script>
